import SeedListPage from '@/modules/seed-list/pages/SeedListPage'

export default [
  {
    name: 'SeedList',
    path: '/account/project/seed-list',
    component: SeedListPage,
    meta: {
      auth: ['viewProjectTechnical'],
      title: 'UserProfiles_SeedList_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/seed-list/router/index.js